import { html, renderIf } from '../../utility/lit-entity';

export function parseSelectedHeaders(importMappingEntity) {
  const mappingTargets = importMappingEntity.getSubEntities('https://api.binsentry.com/rel/mapping-target');
  const headers = mappingTargets.flatMap((target) => target.properties.headers);
  return [...new Set(headers)];
}

export function renderRecordPreviewValue(label, target, recordPreview) {
  const value = Array.isArray(target) ? target.map((t) => recordPreview[t]).join(' ') : recordPreview[target];
  return renderIf(value, html`
    <bn-property stacked label="${label}">${value}</bn-property>
  `);
}
